import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _1680448c = () => interopDefault(import('../pages/401/index.vue' /* webpackChunkName: "pages/401/index" */))
const _0b00bb7c = () => interopDefault(import('../pages/demo/index.vue' /* webpackChunkName: "pages/demo/index" */))
const _9a90b560 = () => interopDefault(import('../pages/forbidden/index.vue' /* webpackChunkName: "pages/forbidden/index" */))
const _44b692e6 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _140594d1 = () => interopDefault(import('../pages/sites/_sid/index.vue' /* webpackChunkName: "pages/sites/_sid/index" */))
const _0b8fef30 = () => interopDefault(import('../pages/preview/_sid/_pageid/_langid/index.vue' /* webpackChunkName: "pages/preview/_sid/_pageid/_langid/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/401",
    component: _1680448c,
    name: "401"
  }, {
    path: "/demo",
    component: _0b00bb7c,
    name: "demo"
  }, {
    path: "/forbidden",
    component: _9a90b560,
    name: "forbidden"
  }, {
    path: "/",
    component: _44b692e6,
    name: "index"
  }, {
    path: "/sites/:sid",
    component: _140594d1,
    name: "sites-sid"
  }, {
    path: "/preview/:sid?/:pageid?/:langid",
    component: _0b8fef30,
    name: "preview-sid-pageid-langid"
  }, {
    path: "/:lang/",
    component: _44b692e6,
    props: true,
    name: "SiteLangIndexPage"
  }, {
    path: "/:lang/:pageid",
    component: _44b692e6,
    props: true,
    name: "SiteLangPagePage"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
